import { AvatarPlaceholder, Logo } from "assets/images";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Chip } from "primereact/chip";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { Menubar } from "primereact/menubar";
import React, { Suspense } from "react";
import { Link } from "react-router-dom";

const ShopKeeperLayout = () => {
  const items = [
    { label: 'Home', icon: 'pi pi-home' },
    { label: 'Store Info', icon: 'pi pi-qrcode' },
    { label: 'Promocode', icon: 'pi pi-question-circle' },
    { label: 'Used Deals', icon: 'pi pi-user' },
    { label: 'Add / Delete', icon: 'pi pi-question-circle' },
    { label: 'Notification', icon: 'pi pi-user' },
  ];
  return (
    <>
      <Suspense>
        <header className='main-header p-festival-header bg-white border-bottom-1 border-primary-color flex justify-content-center align-items-center'>
          <div className='flex justify-content-between align-items-center h-full' style={{ width: "850px" }}>
            <div className='flex flex-wrap align-items-center h-full'>
              <div className='h-full flex align-items-center pr-4 border-right-1 border-primary-color'>
                <Link to='/'><img src={Logo} alt="Logo" className='flex w-14rem' /></Link>
              </div>
              <h4 className='m-0 pl-4'>Decathlons Sports Store, Indore - ID1126587</h4>
            </div>

            <Link to="/" className='flex align-items-center'>
              <p className='mr-2 my-0 avatar-name'><i className="pi pi-wallet"></i>&nbsp;&nbsp; $100</p>
              <Avatar image={AvatarPlaceholder} shape="circle" />
            </Link>
          </div>
        </header>

        <section className="check-deals-section">
          <div className="container">
            <Card className='check-deals-code shadow-none border-bottom-1 border-primary-color mx-auto' style={{ width: "850px" }}>
              <form className="flex align-items-end justify-content-center gap-2">
                <div className="form-group mb-0">
                  <label htmlFor="username1">Check Deals Code</label>
                  <InputText
                    id="email"
                    name="email"
                    placeholder="MYNTRA500"
                  />
                </div>
                <Button label="Check" className='primary' />
              </form>
            </Card>

            <Card className='deals-code shadow-none mt-4 mx-auto' style={{ width: "850px" }}>
              <div className="flex align-items-center justify-content-between gap-2 mb-3">
                <div>
                  <Chip label="MYNTRA500" className="custom-chip" />
                  <Chip label="Paid" icon="pi pi-shopping-bag" className="chip-paid bg-transparent" />
                  <Chip label="Already Used" className="custom-chip already-used" />
                </div>

                <Chip label="Valid till 10th Oct, 24" icon="pi pi-clock" className="bg-transparent" />
              </div>

              <div className='flex align-items-center justify-content-between big-fashion-festival'>
                <div className='w-8'>
                  <h2 className='m-0 mb-2'>Big Fashion Festival</h2>
                  <p className='m-0'>Myntra Big Fashion Festival is Live Now: 50% to 90% OFF + Flat Rs 500 OFF | New Users</p>
                </div>

                <Button label="Redeem Now" className='primary' disabled />
              </div>

              <Fieldset legend="More Details" toggleable className='deals-code-details'>
                <div className="grid">
                  <div className='col-7'>
                    <Card className='shadow-none border-1 border-primary-color'>
                      <strong className='mt-0'>Myntra Big Fashion Festival is Live Now</strong>
                      <ul className="p-list pl-4">
                        <li>Get 50% to 90% OFF on your favourite fashion collections</li>
                        <li>Flat Rs 500 OFF on orders above Rs 1899</li>
                        <li>The coupon code will be applicable on Myntra APP for first-time users only</li>
                        <li>Additional 10% OFF on ICICI, Kotak & Axis Bank Cards</li>
                        <li>7.5% + Extra 5% Discount on Myntra Kotak Credit Card</li>
                        <li>Free Shipping is available</li>
                      </ul>
                    </Card>
                  </div>

                  <div className="col-5">
                    <Chip label="Redeemed on - 1st Oct, 2024 10:30 AM" className="custom-chip" />

                    <ul className='user-details p-list list-none pl-2'>
                      <li><strong>Customer Name:</strong> Jonathan Basett</li>
                      <li><strong>ID:</strong> JB11002</li>
                      <li><strong>Number:</strong> +91 12345 67890</li>
                      <li><strong>Email:</strong> basett@hotmail.com</li>
                    </ul>
                  </div>
                </div>
              </Fieldset>
            </Card>
          </div>
        </section>
        <footer className='p-festival-footer bg-white mt-auto flex justify-content-center check-deal-footer'>
        <Menubar model={items}
          className='bg-white border-0 border-noround'
        />
      </footer>
      </Suspense>
    </>
  )
}
export default ShopKeeperLayout